import { checkIdentitySession } from "../../../core/actions/identity-actions";
import { getSessionExpiredError, logMessage } from "../../../core/actions/common-actions";
import api from "../../../core/helpers/api-services";
import { AppConfigProps } from "../../../core/settings/app-config";
import { USER_CONSENT_DATA } from "../../../store/constants";

const actionFileName = "general-actions.js";

export function getTimeDifferenceSeconds(startTimestamp, endTimestamp) {
  let durationSeconds = null;
  if (startTimestamp && endTimestamp) {
    durationSeconds = parseInt(
      (endTimestamp.getTime() - startTimestamp.getTime()) / 1000
    );
  }
  return durationSeconds;
}

export function getAppConsent(cancelToken) {
  return new Promise(function (resolve, reject) {
      let identitySession = checkIdentitySession();
    if (identitySession === true) {
      api
        .get(
          AppConfigProps.universalConnecterAPIPrefix +
            "/general" +
            "/app-consent",
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (api.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">getAppConsent()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}



export function acceptAppConsent(userConsentObject,cancelToken) {
  return new Promise(function (resolve, reject) {
      let identitySession = checkIdentitySession();
    if (identitySession === true) {
      api
        .post(
          AppConfigProps.universalConnecterAPIPrefix +
            "/general" +
            "/app-consent",userConsentObject,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (api.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">acceptAppConsent()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}

export function withdrawAppConsent(userConsentId,userConsentObject,cancelToken) {
  return new Promise(function (resolve, reject) {
      let identitySession = checkIdentitySession();
    if (identitySession === true) {
      api
        .put(
          AppConfigProps.universalConnecterAPIPrefix +
            "/general" +
            `/app-consent/${userConsentId}`,userConsentObject,
          cancelToken
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          if (api.isCancel(err)) {
            logMessage(
              AppConfigProps.log.severityLevel.warning,
              actionFileName + ">withdrawAppConsent()",
              AppConfigProps.httpStatusCode.clientClosedRequest,
              err.message
            );
          } else {
            reject(err.response);
          }
        });
    } else {
      reject(getSessionExpiredError());
    }
  });
}


export function setUserConsentRecord(userConsentData) {
  return async function (dispatch) {
    try {
      dispatch({
        type: USER_CONSENT_DATA,
        payload: userConsentData,
      });
    } catch (err) {
      throw Error(err);
    }
  };
}
 

